const options = [
  {
    label: 'particulier',
    value: 'particulier',
  },
  {
    label: 'entrepreneur individuel',
    value: 'entrepreneur individuel',
  },
  {
    label: 'société commerciale',
    value: 'société commerciale',
  },
  {
    label: 'collectivité, administration et établissement public hors enseignement',
    value: 'collectivité, administration et établissement public hors enseignement',
  },
  {
    label: 'établissement d\'enseignement',
    value: 'établissement d\'enseignement',
  },
  {
    label: 'comité d\'entreprise',
    value: 'comité d\'entreprise',
  },
  {
    label: 'association et fondation',
    value: 'association et fondation',
  },
  {
    label: 'autre',
    value: 'autre',
  },
];

export default options;



// WEBPACK FOOTER //
// ./src/components/Profile/User/Profile.config.js